import { UI_COMPONENTS_PREFIX_PATH } from 'constants/route.constant'
import { APP_PREFIX_PATH } from 'constants/route.constant'
import {
    NAV_ITEM_TYPE_TITLE,
    NAV_ITEM_TYPE_COLLAPSE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'
import { ADMIN, SUPPORT } from 'constants/roles.constant'

const uiComponentNavigationConfig = [
    {
        key: '',
        path: '',
        title: 'Products',
        translateKey: 'nav.uiComponents',
        icon: 'uiComponents',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [ADMIN, SUPPORT],
        subMenu: [
            {
                key: 'uiComponent.common',
                path: '',
                title: 'Product',
                translateKey: 'nav.uiComponentsCommon.common',
                icon: 'common',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN, SUPPORT],
                subMenu: [
                    {
                        key: 'appsSales.productList',
                        path: `${APP_PREFIX_PATH}/sales/product-list`,
                        title: 'Product List',
                        translateKey: 'nav.appsSales.productList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN, SUPPORT],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.productNew',
                        path: `${APP_PREFIX_PATH}/sales/product-new`,
                        title: 'New Product',
                        translateKey: 'nav.appsSales.productNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN, SUPPORT],
                        subMenu: [],
                    },

                ],
            }
        ],
    },
]

export default uiComponentNavigationConfig
